
	import { email } from '@cnamts/vue-dot/src/rules/email';
	import { required } from '@cnamts/vue-dot/src/rules/required';
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { mdiEyeOff, mdiEye } from '@mdi/js';
	import { FormRef } from '@/types';
	import { Refs } from '@cnamts/vue-dot/src/types';
	import { LoginModel } from '@/services/compte/types';
	import { connectByEmailPassword } from '@/services/compte/api';
	import { StateEnum } from '@cnamts/vue-dot/src/constants/enums/StateEnum';
	import { LocalStorageEnum } from '@/types/enum/LocalStorageEnum';
	import { HttpCodesEnum } from '@/types/enum/HttpCodesEnum';
	import { NOTIFICATION_PATH } from '@/constants/uri';

	@Component
	export default class ConnexionForm extends Vue {
		$refs!: Refs<{
			form: FormRef;
		}>;
		email = '';
		password = '';
		emailRules = [
			email,
			required
		];
		required = required;
		showPassword = false;

		eyeIcon = mdiEye;
		eyeOffIcon = mdiEyeOff;

		StateEnum = StateEnum;
		state: StateEnum = StateEnum.IDLE;

		seConnecter(): void {
			if (localStorage.getItem(LocalStorageEnum.CONFIRMATION_EMAIL_POP_UP)) {
				localStorage.removeItem(LocalStorageEnum.CONFIRMATION_EMAIL_POP_UP);
			}
			if (this.$refs.form.validate()) {
				this.state = StateEnum.PENDING;
				const payload: LoginModel = {
					email: this.email,
					password: this.password
				};

				connectByEmailPassword(payload)
					.then((response) => {
						this.state = StateEnum.RESOLVED;
						if (response.data.token) {
							window.location.href = '/#access_token=' + response.data.token;
						}
					})
					.catch((error) => {
						if (error.response && error.response.status === HttpCodesEnum.HTTP_NOT_FOUND) {
							this.$store.dispatch(NOTIFICATION_PATH, {
								type: 'error',
								message: this.$t('components.authentification.connexion.error404')
							});
						}
						this.state = StateEnum.REJECTED;
					})
				;
			}
		}
	}
